import ButtonNavigation from 'components/commons/buttons/buttonNavigation/ButtonNavigation';
import { iconsState } from 'redux/slices/iconsSlice';
import Ic_Location_White from 'resources/icons/Ic_Info.svg';
import { useSelector } from 'react-redux';

import './cardItemCateory.scss';

interface ICardItemCategory {
    elementId?: string
    title: string
    description:string
    onClick?:any
    onClickNav?:any
    selected?:boolean
    iconId?: number | string,
    background: string,
}

export default function CardItemCategory ({elementId, title, description, onClick, onClickNav, selected, background, iconId}:ICardItemCategory) {
    const iconsSelector = useSelector(iconsState);
    const isIcon = iconsSelector.find((icon)=> icon.id === iconId);
    const ICON = isIcon?.contentFile || Ic_Location_White;
    return (
        <div id={elementId} className={`card-item-category${selected ? '--selected':''}`} onClick={onClick && onClick} style={{background: selected ? background : 'white'}}>
            <div className='category-icon' style={{background}}>
                <img
                    className='marker-img'
                    alt='icono-code-poi'
                    src={ICON}
                    style={{width: 22, height:22}}
                />
            </div>
            <div style={{flex:2, marginTop:'-2px'}}>
                <strong style={{textAlign:'start'}}>{title}</strong>
                <p style={{textAlign:'start'}}>{description}</p>
            </div>
            <div>
                <ButtonNavigation onClick={()=>onClickNav && onClickNav()}/>
            </div>
        </div>
    );
};
